module.exports = __webpack_public_path__ + "static/img/invest-consume13.e9d5238.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/investCase/invest-consume13.jpg
// module id = l0sZ
// module chunks = 0